import * as API from "../../../utils/apiPath";
import { agent } from "../../../utils/agent";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const fetchPendingMentorRequests = createAsyncThunk(
    "pendingMentors/fetch",
    async ({ request, userId }, { rejectWithValue }) => {
        try {
            const response = await agent.get(
                `${API.PENDING_MENTOR_REQUEST}/${userId}`,
                { params: request }
            );

            const data = response.data?.data?.data || [];
            const pagination = response.data?.data?.pagination || {};

            return { data, pagination };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const fetchRegPendingMentorRequests = createAsyncThunk(
    "pendingRegMentors/fetch",
    async ({ request, userId }, { rejectWithValue }) => {
        try {
            const response = await agent.get(
                `${API.PENDING_REG_MENTOR_REQUEST}/${userId}`,
                { params: request }
            );

            const data = response.data?.data?.data || [];
            const pagination = response.data?.data?.pagination || {};

            return { data, pagination };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const pendingMenterRequestSlice = createSlice({
    name: "pendingMenterRequest",
    initialState: {
        data: [],
        pagination: {},
        loading: false,
        notFound: false,
        menteeRequestData: false,
        error: null,
    },

    reducers: {
        toggleNetworkRequestStatus: (state, action) => {
            state.menteeRequestData = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder

            // Pending
            .addCase(fetchPendingMentorRequests.pending, (state, action) => {
                const { request } = action.meta.arg;

                if (request.short || request.keyword || request.page) {
                    state.menteeRequestData = true;
                }

                state.loading = true;
            })

            // Fulfilled
            .addCase(fetchPendingMentorRequests.fulfilled, (state, action) => {
                const { data, pagination } = action.payload;

                state.loading = false;
                state.menteeRequestData = false;

                state.data = data;
                state.pagination = pagination;
                state.notFound = data.length === 0;
            })

            // Rejected
            .addCase(fetchPendingMentorRequests.rejected, (state, action) => {
                state.loading = false;
                state.menteeRequestData = false;
                state.notFound = true;
                state.error = action.payload;
            })
            .addCase(fetchRegPendingMentorRequests.pending, (state, action) => {
                const { request } = action.meta.arg;

                if (request.short || request.keyword || request.page) {
                    state.menteeRequestData = true;
                }

                state.loading = true;
            })

            // Fulfilled
            .addCase(fetchRegPendingMentorRequests.fulfilled, (state, action) => {
                const { data, pagination } = action.payload;

                state.loading = false;
                state.menteeRequestData = false;

                state.data = data;
                state.pagination = pagination;
                state.notFound = data.length === 0;
            })

            // Rejected
            .addCase(fetchRegPendingMentorRequests.rejected, (state, action) => {
                state.loading = false;
                state.menteeRequestData = false;
                state.notFound = true;
                state.error = action.payload;
            });
    },
});

export const { toggleNetworkRequestStatus } = pendingMenterRequestSlice.actions;

export default pendingMenterRequestSlice.reducer;